import React from "react"

const Star = ({ width = "68", height = "68", viewBox = "0 0 68 68" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#a-star-icon)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 34.008c-.005-9.94 8.048-18.001 17.988-18.008A17.99 17.99 0 0 1 52 34c0 9.94-8.056 17.998-17.996 18-9.94.002-18-8.052-18.004-17.992Zm18.005 6.201 7.614 4.59-2.016-8.68 6.714-5.814-8.856-.756-3.456-8.148-3.455 8.171-8.857.756 6.715 5.814-2.016 8.658 7.613-4.59Z"
          fill="#DB1616"
        />
      </g>
      <defs>
        <filter
          id="a-star-icon"
          x="-6"
          y="-6"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix values="0 0 0 0 0.558333 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default Star
